import { useDispatch } from 'react-redux'

import { Dispatch } from '../store'

export default function useDispatchSelector<SelectedDispatch>(
  dispatchSelector: (dispatch: Dispatch) => SelectedDispatch
): SelectedDispatch {
  const dispatch: Dispatch = useDispatch()

  return dispatchSelector(dispatch)
}
